/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData } from '../_common/data/input-data';
import { GAData, Path } from  "../_common/constant/page-const";
import { SINAreYouSureValidation } from './SIN_are_you_sure.validator';

@Component({ 
      selector: 'SIN_are_you_sure',
      templateUrl: './SIN_are_you_sure.component.html',
      styleUrls: ['./SIN_are_you_sure.component.less'],
      //encapsulation: ViewEncapsulation.None
})
export class SINAreYouSureComponent extends FormBaseComponent implements OnInit {

       // declare Field variable here

       constructor( protected router: Router ,
                    public timerService:TimerService,
                    public data:InputData ) {

                    super(router,timerService);  
                    super.setNextPage(Path.ESRMain,Path.SINMain);
                    super.setValidator(new SINAreYouSureValidation(this));
                    ////this.clear();
       }

       public onPreviousClick(){
            super.gtag(GAData.Link,GAData.back_areYouSure);
            super.onPreviousClick();
       }

       public ngOnInit() {
       }

       public onNextClick() : boolean {
              this.clear();
              window.history.back();
              super.gtag(GAData.Button,GAData.continue_product);   
              return true;
       }
     


       public clear() {

            this.data.SIN.clear();
            this.data.clearSINParent();
            
            this.data.SIN.chk_certify = 'X';
       }

}
